import React, { FC, MouseEvent } from 'react'

import { MenuCurrentUser } from 'components/page/PhotoViewer/MenuCurrentUser/MenuCurrentUser'
import { Wrapper } from 'components/page/PhotoViewer/TooltipMenu/ToolTipMenu.styled'
import { MoreActionThreeDotsSvg } from 'components/presentational/svg/MoreActionThreeDotsSvg'
import { RightTopTooltip } from 'components/presentational/Tooltip'

interface TooltipMenuViewCurrentUserProps {
  selectedPhotoIndex: number
  tooltipState: boolean
  onHandleMenuClick: (event: MouseEvent) => void
}

export const TooltipMenuViewCurrentUser: FC<
  TooltipMenuViewCurrentUserProps
> = ({ selectedPhotoIndex, onHandleMenuClick, tooltipState }) => {
  return (
    <Wrapper onClick={onHandleMenuClick} data-name="photo-viewer-menu-action">
      <MoreActionThreeDotsSvg />
      {tooltipState && (
        <RightTopTooltip $minWidth="160px">
          <MenuCurrentUser selectedPhotoIndex={selectedPhotoIndex} />
        </RightTopTooltip>
      )}
    </Wrapper>
  )
}
